import { render } from "./TheThanhTichTongHopTheThaoVH.vue?vue&type=template&id=0f915b5f"
import script from "./TheThanhTichTongHopTheThaoVH.vue?vue&type=script&lang=js"
export * from "./TheThanhTichTongHopTheThaoVH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__